import { createStyles } from "@mantine/core";

export const useStyles = createStyles((theme) => ({
  container: {
    flexDirection: "column",
    marginBlock: "2rem",
    width: "100vw important",
  },
  InlinePadding: {
    paddingInline: "6rem",
    "@media (max-width: 768px)": {
      paddingInline: "2rem",
    },
    "@media (max-width: 430px)": {
      paddingInline: "1rem",
    },
  },
  cards: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  primaryHeading: {
    fontFamily: "Inter",
    fontSize: "50px",
    fontWeight: "400",
    lineHeight: "50px",
    textAlign: "left",
    marginBottom: "30px",
    "@media (max-width: 768px)": {
      fontSize: "30px",
      lineHeight: "30px",
    },
  },
  comingSoonText: {
    fontFamily: "Inter",
    fontSize: "40px",
    fontWeight: "400",
    lineHeight: "50px",
    textAlign: "left",
    marginBottom: "30px",
    "@media (max-width: 768px)": {
      fontSize: "30px",
      lineHeight: "30px",
    },
  },

  cardColor: {
    height: "8px",
    width: "100%",
  },
  Card: {
    flex: "1",
    borderRadius: "24px !important",
    padding: "28px !important",
    position: "relative",
    height: "100%",
    borderColor: "#D4D4D4",
    display: "flex",
    flexDirection: "column",
    "@media (max-width: 600px)": {
      width: "100%",
    },
    "&:hover": {
      borderColor: "#FFAF4A",
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  cast: {
    margin: 0,
    fontSize: "38px",
    lineHeight: "44px",
    "@media (max-width: 1024px)": {
      fontSize: "20px",
    },
  },
  cardButton: {
    width: "100%",
    background: "#171717",
    color: theme.other.white,
    borderRadius: "28px",
    marginBottom: 20,
    height: "50px",
    fontSize: "16px",
    fontFamily: "Inter",
    "&:hover": {
      background: "#FFAF4A",
      color: "#171717",
      borderColor: "#171717",
    },
  },
  cardAmount: {
    display: "flex",
    alignItems: "flex-end",
    fontWeight: "500",
    marginTop: 10,
    fontFamily: "Inter",
    color: "#171717",
    "& p": {
      fontSize: "18px",
      margin: 0,
      textTransform: "lowercase",
    },
  },
  cardList: {
    fontFamily: "Inter",
    padding: "0px 0px 0px 20px !important",
    fontSize: "15px",
    fontWeight: "400",
    lineHeight: "23px",
    color: "#171717",
    marginBlock: 30,
    "& li": {
      listStyleImage: `url('/assets/images/check-icon.png')`,
      marginBlock: "10px",
      paddingLeft: "10px",
    },
  },
  cardStatus: {
    fontSize: "20px",
    fontWeight: "500",
    fontFamily: "Inter",
    lineHeight: "26px",
    color: "#171717",
    marginBottom: 10,
  },

  AccordionHeading: {
    fontSize: "45px",
    lineHeight: "66px",
    marginTop: "60px",
    fontWeight: "400",
    textTransform: "capitalize",
    color: theme.other.black,
    "@media (max-width: 760px)": {
      fontSize: "35px",
      lineHeight: "28px",
    },
    "@media (max-width: 560px)": {
      fontSize: "25px",
      lineHeight: "23px",
    },
  },

  question: {
    fontSize: "25px",
    fontWeight: "400",
    lineHeight: "36px",
    marginTop: "30px",
    color: theme.other.black,
    "@media (max-width: 760px)": {
      fontSize: "22px",
      lineHeight: "28px",
    },
    "@media (max-width: 560px)": {
      fontSize: "20px",
      lineHeight: "23px",
    },
  },

  answer: {
    fontSize: "20px",
    fontWeight: "400",
    lineHeight: "30px",
    color: theme.other.blackLight,
    width: "90%",
    "@media (max-width: 760px)": {
      fontSize: "18px",
      lineHeight: "28px",
    },
    "@media (max-width: 560px)": {
      fontSize: "16px",
      lineHeight: "23px",
      width: "95%",
    },
  },

  chevron: {
    transition: "transform 0.2s ease", // O
    background: "red",
    "&[data-rotate]": {
      transform: "rotate(230deg) !important",
    },
  },

  icon: {
    background: "green",
    width: "16px",
    height: "16px",
  },

  monthlyAndYearlyTab: {
    "& .mantine-Tabs-tabsList": {
      marginBottom: "40px",
      width: "fit-content",
      backgroundColor: "#171717",
      marginInline: "auto",
      borderRadius: "28px",
      padding: "4px",
      "& .mantine-Tabs-tab": {
        color: "#FFFFFF",
        fontFamily: "Inter",
        fontSize: "20px",
        fontWeight: "400",
        padding: "14px 30px",
        borderRadius: "28px",
        "&:hover": {
          backgroundColor: "#171717",
          color: "#FFFFFF",
          opacity: 0.9,
        },
        "&[data-active]": {
          backgroundColor: "#FFAF4A",
          "&:hover": {
            backgroundColor: "#FFAF4A",
            color: "#FFFFFF",
            opacity: "unset",
          },
        },
      },
    },
  },
  enterpriseCard: {
    position: "relative",
    width: "100%",
    borderRadius: "24px !important",
    padding: "18px 28px !important",
    height: "100%",
    border: "1px solid rgba(0, 0, 0, 0.20)",
    background: "linear-gradient(130deg, #FAB714 42.83%, #FFFAC3 84.27%), #FFF",
    display: "flex",
    flexDirection: "column",
    boxShadow:
      "0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
  },
  enterpriseCardHdng: {
    fontSize: "38px",
    fontFamily: "Inter",
    fontWeight: "500",
    color: "#171717",
  },
  enterpriseCardHdngBtn: {
    width: "280px",
    background: "#FFFFFF",
    color: "#171717",
    borderRadius: "28px",
    marginBottom: 20,
    height: "50px",
    fontSize: "16px",
    fontFamily: "Inter",
    "&:hover": {
      background: "#171717",
      color: "#FFFFFF",
      borderColor: "#FFFFFF",
    },
  },
  enterpriseCardTxt: {
    fontSize: "16px",
    fontFamily: "Inter",
    fontWeight: "400",
    color: "#171717",
    marginBlock: 20,
  },
  enterpriseCardImg: {
    width: "60%",
    position: "absolute",
    right: 0,
    bottom: 0,
    '&:nth-of-type(1)':{
      right: -80,
      bottom: -10
    }
  },
  savePerRow: {
    fontSize: "14px",
    fontWeight: "400",
    color: "#171717",
    marginTop: "10px",
    justifyContent: "space-between",
    fontFamily: "Inter",
    "& > p": {
      margin: 0,
    },
    "& > div": {
      border: "1px solid #171717",
      borderRadius: "14px",
      padding: "2px 8px",
      fontSize: "12px",
    },
  },
  trialUsedText: {
    fontSize: "14px",
    fontWeight: "400",
    color: "#666666",
    fontFamily: "Inter",
    textAlign: "center",
  },
}));
